export default class DapGeoLocFixCallbackController {
	static $inject = ['$scope', '$state', '$uibModal', 'registresService', 'notification', '$translate'];

	constructor($scope, $state, $uibModal, registresService, notification, $translate) {
		this.$scope = $scope;
		this.$state = $state;
		this.$uibModal = $uibModal;
		this.registresService = registresService;
		this.notification = notification;
		this.$translate = $translate;
		this.result = [];
	}

	async $onInit() {
		console.log(this.resolve.result.data);
		this.result = this.resolve.result.data;
		console.log('this.result', this.result);
	}
}
